import { useState, useEffect } from "react";
import DashboardAPI from "../../../api/DashboardAPI";

const useFetchDashboard = (userId = null, period = null) => {
	const [loading, setLoading] = useState(false);
	const [dashboard, setDashboard] = useState([]);

	const fetchDashboard = async () => {
		setLoading(true);
		try {
			const result = await DashboardAPI.getDashboardData(userId, period);
			setDashboard(result);
		} catch (error) {
			console.error("Failed to fetch Dashboard:", error);
			setDashboard([]);
			return { success: false, error: error.message };
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchDashboard();
	}, [userId, period]); // re-fetch whenever userId or period changes.

	return {
		dashboard,
		loading,
		refetch: fetchDashboard,
	};
};

export default useFetchDashboard;
